import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const feedbackRoutes = [
  {
    path: '/assignment-feedback-logs',
    name: Routes.ViewAssignmentFeedbackLogs,
    component: () => import('@/pages/contexts/portal/assignment-feedback-logs/Index.vue'),
    meta: {
      pageTitle: 'Assignment Feedback Logs',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_ASSIGNMENT_FEEDBACK_LOGS,
    },
  },
]
